import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PeopleLoadPage } from '@/features/people/PeopleLoadPage';
import { sortSearchParam } from '@/components/data-table/tableSort';
import { monthSearchParam } from '@/features/timesheet/model/searchParams';

// `by` vắng = chế độ Điều phối (mặc định); `person` / `project` = Giờ đã làm. Giá trị lạ coi như vắng.
const byParam = z.unknown().transform((v) => (v === 'person' || v === 'project' ? v : undefined)).optional();

export const Route = createFileRoute('/_authenticated/people/load')({
  validateSearch: z.object({ month: monthSearchParam, by: byParam, s: sortSearchParam }),
  component: function PeopleLoad() {
    const { month, by } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <PeopleLoadPage
        month={month}
        by={by}
        onChange={(next) => void navigate({
          // Về Điều phối thì bỏ cả tháng lẫn sắp xếp; đổi chế độ / cách xem thì bỏ sắp xếp (khoá cột của bảng kia vô nghĩa); chỉ đổi tháng thì giữ.
          search: (prev) => next.by === 'ahead'
            ? {}
            : { month: next.month ?? prev.month, by: next.by ?? prev.by ?? 'person', s: next.by ? undefined : prev.s },
          replace: true,
        })}
      />
    );
  },
});
